import { observer } from 'mobx-react-lite';
import {
    roomPanelFilterSuggestionRoomlist,
    roomPanelFilterSuggestionCity,
} from './RoomFilterSuggestionItem.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';

import RoomFilterIcon from './RoomFilterIcon';
import { RoomFilterType } from './RoomFilterType';
import type RoomFilterWellItemViewState from './RoomFilterWellItemViewState';

import styles from './RoomFilterSuggestionItem.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface RoomFilterSuggestionItemProps {
    colorScheme: ColorScheme;
    viewState: RoomFilterWellItemViewState;
}

/**
 * This is the room filter picker suggestion, used to render an entry in the room filter search drop down
 */
export default observer(function RoomFilterSuggestionItem(props: RoomFilterSuggestionItemProps) {
    const getSuggestionTypeText = (): string => {
        switch (props.viewState.filterType) {
            case RoomFilterType.RoomList: {
                return loc(roomPanelFilterSuggestionRoomlist);
            }
            case RoomFilterType.City: {
                return loc(roomPanelFilterSuggestionCity);
            }
            default: {
                return null;
            }
        }
    };
    let { colorScheme, viewState } = props;
    const suggestionTypeText: string = getSuggestionTypeText();
    return (
        <div className={styles.container} title={viewState.displayText}>
            <div className={styles.coin}>
                <RoomFilterIcon
                    colorScheme={colorScheme}
                    square={viewState.filterType === RoomFilterType.RoomList}
                    roomFilterType={viewState.filterType}
                />
            </div>
            <div className={styles.suggestionText}>
                <div className={classNames(styles.displayName, styles.suggestionLine)}>
                    {renderDisplayName(viewState)}
                </div>
                <div className={classNames(styles.suggestionTypeText, styles.suggestionLine)}>
                    {suggestionTypeText}
                </div>
            </div>
        </div>
    );
});

function renderDisplayName(viewState: RoomFilterWellItemViewState): JSX.Element {
    if (viewState.queryString) {
        const matchStartIndex: number = viewState.displayText
            .toLocaleLowerCase()
            .indexOf(viewState.queryString.toLocaleLowerCase());
        if (matchStartIndex >= 0) {
            return (
                <div className={styles.suggestionLine}>
                    <span>{viewState.displayText.substr(0, matchStartIndex)}</span>
                    <span className={styles.highlightedText}>
                        {viewState.displayText.substr(
                            matchStartIndex,
                            viewState.queryString.length
                        )}
                    </span>
                    <span>
                        {viewState.displayText.substr(
                            matchStartIndex + viewState.queryString.length
                        )}
                    </span>
                </div>
            );
        }
    }
    return <span>{viewState.displayText}</span>;
}
